import { render, staticRenderFns } from "./MockASPSP.vue?vue&type=template&id=56662e41&"
import script from "./MockASPSP.vue?vue&type=script&lang=js&"
export * from "./MockASPSP.vue?vue&type=script&lang=js&"
import style0 from "./MockASPSP.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports